/**
 * Created by mgoria on 1/21/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidSqsQueueUrlException = undefined;

var _LogDriverException2 = require('./LogDriverException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when SQS queue url is invalid
 */
let InvalidSqsQueueUrlException = exports.InvalidSqsQueueUrlException = function (_LogDriverException) {
  _inherits(InvalidSqsQueueUrlException, _LogDriverException);

  /**
   * @param {String} sqsQueueUrl
   * @param {Object|String} error
   */
  function InvalidSqsQueueUrlException(sqsQueueUrl, error) {
    _classCallCheck(this, InvalidSqsQueueUrlException);

    return _possibleConstructorReturn(this, (InvalidSqsQueueUrlException.__proto__ || Object.getPrototypeOf(InvalidSqsQueueUrlException)).call(this, `Invalid SQS queue url "${sqsQueueUrl}". ${error}`));
  }

  return InvalidSqsQueueUrlException;
}(_LogDriverException2.LogDriverException);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/Exception/InvalidSqsQueueUrlException.js
// module id = 402
// module chunks = 0